/*
 * Module for the Payment Options Step of the MemberDirect Retirement Application wizard
*/
rs.module("content/benefits/retirementapplication/paymentoptionsstep",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var paymentOptionRadio = stepContainer.js(jsSelectors.paymentOptionRadio, { multiple: true });
            var paymentOptionDescriptionDiv = stepContainer.js(jsSelectors.paymentOptionDescriptionDiv, { multiple: true });

            var selectedIndex = paymentOptionRadio.index(paymentOptionRadio.filter(":checked"));
            if (selectedIndex && selectedIndex >= 0) {
                showSelectedPaymentOptionDescription(selectedIndex);
            }

            // Handle the paymentOptionRadio change event
            paymentOptionRadio.on("change", function () {

                var selectedIndex = paymentOptionRadio.index(this);
                showSelectedPaymentOptionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected payment option
            function showSelectedPaymentOptionDescription(selectedIndex) {

                // Close all quickly
                paymentOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                paymentOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);